import { jsonFetch } from "@/lib/helpers";
import { GET_AVAILABLE_DEVICE_VERSION } from "./api-url.constants";

export type VersionInfo = {
  version: string;
  date: string;
};

export type AvailableVersions = {
  staging: VersionInfo;
  production: VersionInfo;
};

export const getAvailableDeviceVersion = async (): Promise<AvailableVersions> => {
  const availableDeviceVersion = await jsonFetch<{ data: AvailableVersions }>(
    GET_AVAILABLE_DEVICE_VERSION
  );
  return availableDeviceVersion.data;
};
